import { createStore } from 'vuex'

import { store as template } from '@f1/upc-webapp-ui-vue3'

const store = createStore({
    modules: {
        template
    },
})
export default store
